const dev = {
  SERVICE_ENDPOINTS: {
    'cs-auth': 'https://api-qa.codehall.in/auth',
    copdg: 'https://api-qa.codehall.in/copdg',
    assessment: 'https://api-qa.codehall.in/assessment',
    'code-exec': 'https://api-qa.codehall.in/code-exec',
    interview: 'https://api-qa.codehall.in/interview',
    ws: 'wss://api-qa.codehall.in/interview',
    'common-ws': 'wss://api-qa.codehall.in/websocket',
    'question-bank': 'https://questionbank-api-qa.codehall.in',
  },
  ANALYTICS_ID: 'UA-154448491-1',
  STAGE: 'dev',
  LOGO_BASE_URL: 'https://assessment-qa.codehall.in/company_logos/',
};

const prod = {
  STAGE: 'prod',
  SERVICE_ENDPOINTS: {
    'cs-auth': 'https://auth-api-prod.codehall.in',
    copdg: 'https://copdg-api-prod.codehall.in',
    assessment: 'https://assessment-api-prod.codehall.in',
    'code-exec': 'https://codeexec-api-prod.codehall.in',
    interview: 'https://interview-api-prod.codehall.in',
    ws: 'wss://interview-api-prod.codehall.in',
    'common-ws': 'wss://websocket-api-prod.codehall.in',
    'question-bank': 'https://questionbank-api-prod.codehall.in',
  },
  ANALYTICS_ID: 'UA-154448491-1',
  LOGO_BASE_URL: 'https://assessment.codehall.in/company_logos/',
};

const qa = {
  STAGE: 'qa',
  SERVICE_ENDPOINTS: {
    'cs-auth': 'https://auth-api-qa.codehall.in',
    copdg: 'https://copdg-api-qa.codehall.in',
    assessment: 'https://assessment-api-qa.codehall.in',
    'code-exec': 'https://codeexec-api-qa.codehall.in',
    interview: 'https://interview-api-qa.codehall.in',
    ws: 'wss://interview-api-qa.codehall.in',
    'common-ws': 'wss://websocket-api-qa.codehall.in',
    'question-bank': 'https://questionbank-api-qa.codehall.in',
  },
  ANALYTICS_ID: 'UA-154448491-1',
  LOGO_BASE_URL: 'https://assessment-qa.codehall.in/company_logos/',
};

export const local = {
  ...dev,
  /* uncomment and add your service endpoints here
     make sure you have a file named .env.development.local where
     REACT_APP_STAGE is set to local*/
  SERVICE_ENDPOINTS: {
    ...dev['SERVICE_ENDPOINTS'],
    'cs-auth': `https://auth-api-${process.env.REACT_APP_STAGE}.codehall.in`,
    copdg: `https://copdg-api-${process.env.REACT_APP_STAGE}.codehall.in`,
    assessment: `https://assessment-api-${process.env.REACT_APP_STAGE}.codehall.in`,
    'code-exec': `https://codeexec-api-${process.env.REACT_APP_STAGE}.codehall.in`,
    interview: `https://interview-api-${process.env.REACT_APP_STAGE}.codehall.in`,
    ws: `wss://interview-api-${process.env.REACT_APP_STAGE}.codehall.in`,
    'common-ws': `wss://websocket-api-${process.env.REACT_APP_STAGE}.codehall.in`,
  },
};

let config = null;
if (process.env.REACT_APP_STAGE === 'prod') {
  config = prod;
} else if (process.env.REACT_APP_STAGE === 'qa') {
  config = qa;
} else if (process.env.REACT_APP_STAGE === 'dev') {
  config = dev;
} else {
  config = local;
}

export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config,
};
